import { render, staticRenderFns } from "./AdminAuth.vue?vue&type=template&id=5106419b&scoped=true&"
import script from "./AdminAuth.vue?vue&type=script&lang=js&"
export * from "./AdminAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5106419b",
  null
  
)

export default component.exports